<template>
  <div :class="['tab-container__item achievements_tab', { active: isActive }]">
    <div class="achievements_container">
      <achievement-category v-for="(category, index) in categories"
                            :category="category.achievementName"
                            :category-value="category.achievementNameTranslation"
                            :achievements="category.achievementLevelDTOs"
                            :key="index"/>
    </div>
  </div>
</template>

<script>
import AchievementCategory from '@/components/home/achievements/AchievementCategory';

export default {
  name: 'achievements-tab',
  props: {
    isActive: { type: Boolean, default: false },
    categories: Array,
  },
  components: {
    AchievementCategory,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/achievements/AchievementsTab.vue